export const SkuMappingWorkflowStepStatus = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  SKIPPED: 'SKIPPED',
  WAITING_FOR_EXTERNAL_PROCESSING: 'WAITING_FOR_EXTERNAL_PROCESSING',
  EXTERNAL_PROCESSING_COMPLETED: 'EXTERNAL_PROCESSING_COMPLETED',
};

export const SkuMappingWorkflowStepStatusConfig = {
  [SkuMappingWorkflowStepStatus.PENDING]: {
    variant: 'secondary',
    text: 'Pending',
  },
  [SkuMappingWorkflowStepStatus.IN_PROGRESS]: {
    variant: 'primary',
    text: 'In Progress',
  },
  [SkuMappingWorkflowStepStatus.COMPLETED]: {
    variant: 'success',
    text: 'Completed',
  },
  [SkuMappingWorkflowStepStatus.FAILED]: {
    variant: 'danger',
    text: 'Failed',
  },
  [SkuMappingWorkflowStepStatus.SKIPPED]: {
    variant: 'warning',
    text: 'Skipped',
  },
  [SkuMappingWorkflowStepStatus.WAITING_FOR_EXTERNAL_PROCESSING]: {
    variant: 'info',
    text: 'Waiting for Processing',
  },
  [SkuMappingWorkflowStepStatus.EXTERNAL_PROCESSING_COMPLETED]: {
    variant: 'success',
    text: 'Processing Complete',
  },
};

export const SkuMappingWorkflowTypes = {
  VENDOR: 'VENDOR',
  DAILY: 'DAILY',
  BRAND: 'BRAND',
};

export const SkuMappingWorkflowTypesConfig = {
  [SkuMappingWorkflowTypes.VENDOR]: {
    label: 'Distributor',
    value: SkuMappingWorkflowTypes.VENDOR,
  },
  [SkuMappingWorkflowTypes.DAILY]: {
    label: 'Daily',
    value: SkuMappingWorkflowTypes.DAILY,
  },
  [SkuMappingWorkflowTypes.BRAND]: {
    label: 'Brand',
    value: SkuMappingWorkflowTypes.BRAND,
  },
};
